<template>
  <div class="skeleton">
    <div v-for="n in rows" :key="n" class="skeleton__row" :style="{ marginBottom: rowGap }">
      <div v-if="avatar" class="skeleton__avatar" :style="avatarStyle" />
      <div class="skeleton__line" :style="lineStyle(n - 1)" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Skeleton',
  props: {
    rows: { type: Number, default: 3 },
    avatar: { type: Boolean, default: false },
    avatarSize: { type: String, default: '40px' },
    avatarShape: { type: String, default: 'rect' }, // 'rect' | 'circle'
    radius: { type: Number, default: 4 },
    lineHeight: { type: String, default: '14px' },
    rowGap: { type: String, default: '12px' },
    lineWidths: { type: Array, default: () => [] }
  },
  computed: {
    avatarStyle() {
      return {
        width: this.avatarSize,
        height: this.avatarSize,
        borderRadius: this.avatarShape === 'circle' ? '50%' : this.radius + 'px'
      }
    }
  },
  methods: {
    lineStyle(idx) {
      const width = this.lineWidths.length ? (this.lineWidths[idx] || this.lineWidths[this.lineWidths.length - 1]) : this.defaultWidth(idx)
      return {
        width,
        height: this.lineHeight,
        borderRadius: this.radius + 'px'
      }
    },
    defaultWidth(idx) {
      // fallback pattern: 100%, 90%, 80%, 95% ...
      const patterns = ['100%', '90%', '80%', '95%', '85%']
      return patterns[idx % patterns.length]
    }
  }
}
</script>

<style scoped lang="less">
.skeleton {
  .skeleton__row { display: flex; align-items: center; }
  .skeleton__avatar,
  .skeleton__line {
    background: linear-gradient(90deg, #f2f2f2 25%, #e8e8e8 37%, #f2f2f2 63%);
    background-size: 400% 100%;
    animation: shimmer 1.2s ease-in-out infinite;
  }
  .skeleton__avatar { margin-right: 12px; flex: 0 0 auto; }
  .skeleton__line { flex: 1 1 auto; }
}

@keyframes shimmer {
  0% { background-position: 0% 0; }
  100% { background-position: -200% 0; }
}
</style>